import Table from 'components/Table';
import { ItableColumn, TableProps } from 'components/Table/type';
import React from 'react';
import { inputVal } from 'tradevan-ui/consts';
import { dateStrParse, formatDate } from 'components/DatePicker/consts';
import DateEnum from 'components/DatePicker/enum';
import Modal from 'tradevan-ui/Modal';

import { IlogRecordQuery } from 'view/Layout/Project/components/LogRecordModal/type';
import { EnumLogRecordQuery } from './enum';

interface RowDetailProps {
  _show: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
  data: IlogRecordQuery[];
}
/** 操作歷程 Modal */
const LogRecordModal = (props: RowDetailProps) => {
  const {
    _show: [show, setShow],
    data,
  } = props;

  const column: ItableColumn[] = [
    { title: '檢視日期', field: EnumLogRecordQuery.downloadDate },
    { title: '檢視方式', field: EnumLogRecordQuery.docType },
    { title: '檢視帳號', field: EnumLogRecordQuery.userId },
    { title: '版次', field: EnumLogRecordQuery.version },
  ];

  const renderCell: TableProps<IlogRecordQuery>['renderCell'] = (params) => {
    const { field, row, value } = params;
    /** 日期格式轉換 */
    const converDate = (
      dateStr: string,
      targetDateFormat: DateEnum,
      returnDateFormat: DateEnum,
    ) => {
      return formatDate(returnDateFormat)(
        dateStrParse(targetDateFormat)(inputVal(dateStr)),
      );
    };

    switch (field) {
      case EnumLogRecordQuery.downloadDate: {
        return inputVal(
          converDate(
            value,
            DateEnum.yyyyMMddHHmmss,
            DateEnum['yyyy/MM/dd HH:mm:ss'],
          ),
        );
      }
      case EnumLogRecordQuery.docType: {
        return (
          <>
            {inputVal(row[EnumLogRecordQuery.docTypeName])}{' '}
            {inputVal(row[EnumLogRecordQuery.actionTypeName])}
          </>
        );
      }

      default:
        break;
    }
    return undefined;
  };

  return (
    <Modal
      backdrop="static"
      header={<b style={{ color: 'white' }}>點閱紀錄</b>}
      show={show}
      onHide={() => {
        setShow(false);
      }}
    >
      <Table data={data} columns={column} renderCell={renderCell} />
    </Modal>
  );
};
export default LogRecordModal;
